import React from 'react';
import IconTitleButton from "../buttons/IconTitleButton";

import ICArrow from "res/images/doted_arrow.png";

export default function Stepper(props) {
    return (<table>
        <tbody>
        <tr>
            {props.items.map((item, index) => {
                let isLastItem = props.items[props.items.length - 1].id === item.id
                return <div key={index}>
                    <td className="center" onClick={item.onClick}>
                        {item.image &&
                        <div style={{padding: "1em"}} className="marginSmall">
                            <IconTitleButton
                                isvertical={"true"}
                                title={item.title}
                                icon={<img style={{
                                    width: props.itemWidth ? props.itemWidth : "4.5em",
                                    height: props.itemHeight ? props.itemHeight : "4.5em"
                                }} src={item.image} alt=""/>}
                                onClick={props.onClick ? props.onClick : undefined}/>
                        </div>
                        }
                    </td>
                    {!isLastItem &&
                    <td>
                        <img className="smallIcon" src={ICArrow} alt=""/>
                    </td>
                    }
                </div>
            })}
        </tr>
        </tbody>
    </table>)
}